import styled from "styled-components";

export const StyledMarketListWrapper = styled.div`
    overflow-y: auto;
`;
